import { validateLastName } from 'core/service/insured'
import { SELECT_PRODUCT } from 'quick-quote/product-selection/actions'
import { RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE } from 'quick-quote/product-sio/actions'
import { RESET_APPLICATION_STATE, RESET_QUOTE_FORM } from 'quick-quote/actions'
import messages from 'core/data-model/constants/messages'
import VALUES from 'core/data-model/constants/values'

const defaultState = {
  name: messages.LAST_NAME_DEFAULT,
  defaultValue: messages.LAST_NAME_DEFAULT,
  errors: [],
}

const redux = (validateName) => (namespace, initialState) => {
  const finalInitialState = initialState || defaultState

  // actions
  const EDIT_NAME = `${namespace}/EDIT_NAME`
  const CLEAR_NAME = `${namespace}/CLEAR_NAME`
  const editName = (name) => ({
    type: EDIT_NAME,
    payload: name,
  })

  // reducer
  const reducer = (state = finalInitialState, action) => {
    switch (action.type) {
      case SELECT_PRODUCT:
        return state
      case CLEAR_NAME:
      case RESET_QUOTE_FORM:
      case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
      case RESET_APPLICATION_STATE:
        return { ...state, name: '', errors: [] }
      case EDIT_NAME:
        let inputPayload =
          action.payload.length > VALUES.LAST_NAME_MAX_LENGTH
            ? action.payload.substring(0, VALUES.LAST_NAME_MAX_LENGTH)
            : action.payload
        return {
          ...state,
          name: inputPayload,
          errors: validateName(inputPayload),
        }
    }

    return state
  }

  // selectors
  const getName = (state) => (state ? state.name : '')
  const getDefaultValue = (state) => (state ? state.defaultValue : '')
  const getErrors = (state) => (state ? state.errors : '')

  return {
    initialState: finalInitialState,
    actions: { EDIT_NAME },
    actionCreators: { editName },
    reducer,
    selectors: { getName, getDefaultValue, getErrors },
  }
}

export default redux

export const LastNameRedux = redux(validateLastName)('LAST_NAME')
